<template>
  <div class="notes_window channel_window">
    <button @click="viewNote" v-if="!hideNoteIcon" class="ace_sec btn_ic">
      <span>
        <span class="ic ico-notes action-icon-note"></span>
      </span>
    </button>
    <div>
      <b-modal id="send-group-note-popup" class="full_screen_modal" ref="shareNoteMessageModal" :header-bg-variant="'send-group-note-popup-header'" size="" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt head_txt">
            <span v-if="userIds.length > 1">{{selectedNoteType}} Note About {{userIds.length}} People</span>
            <span v-else>{{sendGroupMessageText}}</span>
          </div>
          <div>
            <button class="btn_close" aria-label="close" @click="cancelShareNoteMessage">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="ch_mid_sec">
          <div class="text-center">
            <span v-if="!hideNoteIcon">
              <select class="mr-1" v-model="selectedNoteType">
                <option v-for="option in noteTypeOptions" v-bind:value="option">{{option}}</option>
              </select>
            </span>
            <span>{{sendGroupMessageText.replace(selectedNoteType, '')}}</span>
          </div>

          <div class="channel-section msg_sec_container">
            <div class="msg_row_section">
              <div class="msg_section_inner">
                <div class="chat-message" style="margin-bottom: 2px;" v-for="message in sendMessages">
                  <div class="message-avatar-default">
                    <span class="icon-user"></span>
                  </div>
                  <div class="message-details">
                    <div class="message-author-name">
                      <span class="message-author">{{message.name}}</span>
                      <span class="message-time">{{get12HourTime(message.date)}}</span>
                    </div>
                    <div class="message">
                      <div class="message-content float-left" v-html="message.text"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field-section">
          <label :for="editorInstanceId" class="visibility_hide">Add note</label>
          <editor api-key="no-api-key"
            v-model.trim="sendMessage"
            :init="({
              base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
              menubar: false,
              plugins: plugins,
              toolbar: toolbar,
              branding: false,
              statusbar: false,
              end_container_on_empty_block: true
            })"
            @onInit="handlerInit"
            @onKeyUp="handlerKeyUp"
            class="ace_sec"
            :id="editorInstanceId">
          </editor>
          <div class="right-section rich-text-editor-btn">
            <div class="send_btn_container">
              <button type="submit" value="send" class="send-btn btn ace_sec" @click="send(true)">
                <span class="ic9-send ic9-iconSend-0001">
                  <span class="visibility_hide">send</span>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="mt-1">
          <div class="float-right" v-if="sendMessage.length > 10">
            <span class="mr-3"><small><b>Enter</b> to send</small></span>
            <span><small><b>Shift + Enter</b> to add a new line</small></span>
          </div>
        </div>
      </b-modal>
    </div>
    <bad-words-prompt ref="badWordsAlert" @sendMaskedBadWords="sendMaskedBadWords" :editorInstanceId="editorInstanceId"></bad-words-prompt>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapActions } from 'vuex'
  import Editor from '@tinymce/tinymce-vue'
  import { db } from '../../../firebase'
  import { StorageFactory } from '../../../storageFactory'
  import BadWordsPrompt from '../../channel/components/BadWordsPrompt'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'note-action-menu',
    props: ['action', 'userIds', 'senderId', 'hideNoteIcon', 'noteType'],
    components: {
      Editor,
      BadWordsPrompt
    },
    data: (vm) => {
      return {
        messages: [],
        sendMessage: '',
        sharedNotes: [],
        privateNotes: [],
        userChannelIdMap: {},
        uuidDisplayNameMap: {},
        messageType: 'Message',
        typeUserChannelIdMap: {},
        groupMessageUserNames: [],
        isActionModalVisible: false,
        userId: localStore.getItem('userid'),
        userRole: localStore.getItem('userrole'),
        userName: localStore.getItem('userFullName'),
        plugins: 'lists  autolink charmap code hr link textcolor',
        toolbar: 'bold italic strikethrough | bullist numlist | indent outdent | alignleft aligncenter alignright | forecolor backcolor | removeformat link unlink',
        selectedNoteType: vm.noteType || 'Private',
        noteTypeOptions: ['Private', 'Shared']
      }
    },
    computed: {
      editorInstanceId () {
        let instanceId = 'groupNoteRichTextMessage'
        if (this.action === 'view') {
          instanceId += '_' + this.userIds[0].userUuid
        }
        return instanceId
      },
      sendGroupMessageText () {
        let length = this.groupMessageUserNames.length
        let text = this.selectedNoteType + ' Note About '
        if (length > 1) {
          text += length + ' people including ' + this.groupMessageUserNames.join(', ').replace(/,(?=[^,]*$)/, ' and')
        } else {
          text += this.groupMessageUserNames[0]
        }
        return text
      },
      sendMessages () {
        if (this.selectedNoteType === 'Shared') {
          return this.sharedNotes
        }
        return this.privateNotes
      }
    },
    watch: {
      selectedNoteType (newValue) {
        this.userChannelIdMap = this.typeUserChannelIdMap[newValue]
      }
    },
    methods: {
      ...mapActions([
        'loadParticipantDisplayNames',
        'loadAdvisorChannelIdsForSelectedUsers'
      ]),
      async viewNote () {
        let userUuids = _.map(this.userIds, 'userUuid')
        this.uuidDisplayNameMap = await this.loadParticipantDisplayNames(userUuids)
        this.typeUserChannelIdMap = await this.loadAdvisorChannelIdsForSelectedUsers(userUuids)
        this.userChannelIdMap = this.typeUserChannelIdMap[this.selectedNoteType]
        this.groupMessageUserNames = Object.values(this.uuidDisplayNameMap)
        setTimeout(() => {
          this.isActionModalVisible = true
          this.$refs.shareNoteMessageModal.show()
          $('.advisee_sec_crd').addClass('active')
        }, 500)
      },
      cancelShareNoteMessage () {
        this.messages = []
        this.sendMessage = ''
        this.sharedNotes = []
        this.privateNotes = []
        this.userChannelIdMap = {}
        this.uuidDisplayNameMap = {}
        this.typeUserChannelIdMap = {}
        this.groupMessageUserNames = []
        this.selectedNoteType = 'Private'
        this.isActionModalVisible = false
        this.$refs.shareNoteMessageModal.hide()
        this.$parent.$parent.selectedUserUuids = []
        this.$parent.$parent.selectedItemMessage=''
        this.$parent.$parent.pageSelected = false
        $('.advisee_sec_crd').removeClass('active')
      },
      preventEnterKeyEvent (container, ed) {
        $(container).keydown((e) => {
          const keyPressed = e.keyCode || e.which
          if ((keyPressed === 13) && !e.shiftKey) {
            let content = ed.getContent().replace(/<p>&nbsp;<\/p>/g, '')
            ed.setContent(content)
            ed.selection.select(ed.getBody(), true)
            ed.selection.collapse(false)
            return false
          }
        })
      },
      handlerInit (ev, editor) {
        let elemId = '#' + this.editorInstanceId + '_ifr'
        $(elemId).width('calc(100% - 60px)')
        $(elemId).height('72px')
        $('.field-section').css('visibility', 'visible')
        let container = $(elemId)[0].contentWindow.document.body
        this.preventEnterKeyEvent(container, editor)
        $('.mce-top-part').css({'width': '100%', 'padding-left': '0px'})
      },
      handlerKeyUp (ev, editor) {
        const keyPressed = ev.keyCode || ev.which
        if (((keyPressed === 13) && !ev.shiftKey) || ((keyPressed === 17) && (ev.target.innerHTML.indexOf('<img') !== -1))) {
          let isBadWordsNotAllowed = (keyPressed === 13) || (ev.target.innerHTML.indexOf('<img') === -1)
          this.send(isBadWordsNotAllowed)
        }
      },
      sendMaskedBadWords () {
        this.send(false)
      },
      async send (isBadWordsNotAllowed) {
        if (this.sendMessage.length > 0) {
          let isNotAllowed = this.$refs.badWordsAlert.showPrompt(this.sendMessage, isBadWordsNotAllowed)
          if (!isNotAllowed) {
            this.sendMessage = this.sendMessage.replaceAll(/<p style=.*>&nbsp;<\/p>/g, '').replaceAll(/<p>&nbsp;<\/p>/g, '')
            if (this.sendMessage && this.sendMessage.length > 1) {
              this.sendMessage = this.sendMessage.replaceAll('<a', '<a style="color: #0645AD;" target="_blank" rel="noopener"')
              this.sendMessage = this.sendMessage.replace('<img', '<img style="width: 350px; height: 200px; cursor: zoom-in;" class="open-img-modal"')
              this.sendMessage = this.$refs.badWordsAlert.maskBadWords(this.sendMessage)
              let date = new Date()
              let dd = date.getDate()
              let mm = date.getMonth() + 1
              let yyyy = date.getFullYear()
              let hr = date.getHours()
              let mn = date.getMinutes()
              if (mn < 10) {
                mn = '0' + mn
              }
              const message = {
                name: this.userName,
                role: this.userRole,
                uuid: this.userId,
                text: this.sendMessage,
                date: mm + '/' + dd + '/' + yyyy + ' ' + hr + ':' + mn,
                type: this.messageType
              }
              this.sendMessageToUsers(message)
            }
          }
        }
      },
      sendMessageToUsers (message) {
        let selectedUserIds = _.map(this.userIds, 'userUuid')
        selectedUserIds.forEach(selectedUserId => {
          let channelId = this.userChannelIdMap[selectedUserId]
          if (channelId) {
            this.$bindAsArray('messages', db.ref('channels/' + channelId + '/Messages'))
            this.$firebaseRefs.messages.push(message)
          }
        })
        this.sendMessage = ''
        if (this.selectedNoteType === 'Shared') {
          this.sharedNotes.push(message)
        } else {
          this.privateNotes.push(message)
        }
      },
      get12HourTime (datetime) {
        let values = datetime.split(' ')
        let hrmn = values[1].split(':')
        let hr = hrmn[0]
        let mn = hrmn[1]
        let ampm = hr >= 12 ? 'pm' : 'am'
        hr = hr % 12
        hr = hr ? hr : 12
        let time = values[0] + ' ' + hr + ':' + mn + ' ' + ampm
        return time
      }
    }
  }
</script>

<style>
  .action-icon-note {
    font-size: 30px;
  }

  .action-icon-note:hover {

  }

  .popup_head_txt {
    font-weight: 800;
    font-size: 1.4rem;
  }

  .bg-send-group-note-popup-header {

  }

  #groupNoteRichTextMessage {
    height: 86px;
    width: calc(100% - 85px);
    padding-left: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/NoteActionMenu.vue